// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@flip/App/Components/Common/XngZone";
import { xScreen } from "@flip/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

interface BrandPageLayoutStyles {
    wrapper?: InjectableCss;
    bannerSection?: InjectableCss;
    bannerWrapper?: InjectableCss;
    infoSection?: InjectableCss;
    mainSection?: InjectableCss;
    logoActionsSection?: InjectableCss;
}

const brandPageLayoutStyles: BrandPageLayoutStyles = {
    mainSection: {
        css: css`
            width: 100%;  
        `,
    },
    logoActionsSection: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 32px;
            > div:first-child {
                margin-right: 8px;
            }

            ${xScreen("lte", "sm")} {
                flex-direction: column;

                > div {
                    width: 100%;
                    margin-right: 0;
                }
            }
        `,
    },
};

const styles = brandPageLayoutStyles;

export const BrandPageLayout: FC<Props> = ({ id }) => {

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.bannerSection} data-test-selector="Banner">
                {createWidgetElement("BrandDetails/BrandDetailsLogo", {
                    fields: {
                        showTitleOnly: true,
                    },
                })}
            </StyledWrapper>
            <StyledWrapper {...styles.mainSection} data-test-selector="MainSection">
                <StyledWrapper {...styles.logoActionsSection}>
                    <XngZone contentId={id} zoneName="Content01" hint="Logo Section" />
                    <XngZone contentId={id} zoneName="Content02" hint="Links Section" normalWidth={true} />
                </StyledWrapper>
                <XngZone contentId={id} zoneName="Content03" hint="Image Section" />
                <XngZone contentId={id} zoneName="Content04" hint="Description Section" />
                <XngZone contentId={id} zoneName="Content05" hint="Shop by category Section" />
                <XngZone contentId={id} zoneName="Content06" hint="Product lines Section" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandPageLayout,
    definition: {
        group: "Brand Details",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
